import * as React from 'react';
import { FC } from 'react';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { StoreSelector as StoreLocatorRefresh } from './new-ui';
import { StoreSelector as StoreLocatorOldUI } from './old-ui';
import { IStoreSelectorProps } from './types';

/**
 *
 * StoreSelectorContainer purpose
 *
 */
export const StoreSelectorContainer: React.FC<IStoreSelectorProps> = ({
  onDismiss,
  updateStore,
}) => {
  const useLocatorRefreshUI = useFlag(LaunchDarklyFlag.ENABLE_LOCATOR_UI_REFRESH);
  return useLocatorRefreshUI ? (
    <StoreLocatorRefresh onDismiss={onDismiss} updateStore={updateStore} />
  ) : (
    <StoreLocatorOldUI onDismiss={onDismiss} updateStore={updateStore} />
  );
};

export default StoreSelectorContainer;
